import {EntityWithId, EntityWithIdAndDescription} from '../baseEntities'

export enum GroupDTOFields {
    Name = 'nombre',
    ProfileId = 'idPerfil',
    Observations = 'observaciones',
    CodPais = 'codPais',
    CodSistema = 'codSistema',
    IdGrupoPadre = 'idGrupoPadre',
    CodTipoGrupo = 'codGrupoTipo'
}

export enum GroupViewDTOFields {
    ProfileName = 'nombrePerfil',
    Active = 'estaActivo',
    CodPais = 'codPais',
    CodSistema = 'codSistema',
    NombreSistema = 'nombreSistema',
    CountryName = 'nombrePais',
    IdGrupoPadre = 'idGrupoPadre',
    NombreGrupoPadre = 'nombreGrupoPadre',
    CodTipoGrupo = 'codGrupoTipo',
    NombreTipoGrupo = 'nombreGrupoTipo'
}

export type GroupDTO = {
    [GroupDTOFields.Name]: string
    [GroupDTOFields.ProfileId]: number
    [GroupDTOFields.Observations]: string
    [GroupDTOFields.CodPais]: number
    [GroupDTOFields.CodSistema]: number
    [GroupDTOFields.IdGrupoPadre]: number
    [GroupDTOFields.CodTipoGrupo]: number
}

export type GroupViewDTO = GroupDTO &
    EntityWithId<number> & {
    [GroupViewDTOFields.ProfileName]: string
    [GroupViewDTOFields.Active]: boolean
    [GroupViewDTOFields.CodPais]: number
    [GroupViewDTOFields.CodSistema]: number
    [GroupViewDTOFields.CountryName]: string
    [GroupViewDTOFields.NombreSistema]: string
    [GroupViewDTOFields.IdGrupoPadre]: number
    [GroupViewDTOFields.NombreGrupoPadre]: string
    [GroupViewDTOFields.NombreTipoGrupo]: string
}

export type GroupInsertDTO = GroupDTO

export enum GroupFilterDTOFields {
    Name = 'nombre',
    ActiveOnly = 'soloActivos',
    CodsPais = 'codsPais',
    CodsTipoMensaje = 'codsTipoMensaje'
}

export type GroupFilterDTO = {
    [GroupFilterDTOFields.Name]?: string
    [GroupFilterDTOFields.ActiveOnly]?: boolean
    [GroupFilterDTOFields.CodsPais]?: number[]
    [GroupFilterDTOFields.CodsTipoMensaje]?: number[]
}

export enum GroupSectorComercialViewDTOFields {
    CodSectorComercial = 'codSectorComercial',
    NombreSectorComercial = 'nombreSectorComercial',
    PerteneceASector = 'perteneceASector'
}

export type GroupSectorComercialViewDTO = {
    [GroupSectorComercialViewDTOFields.CodSectorComercial]: number
    [GroupSectorComercialViewDTOFields.NombreSectorComercial]: string
    [GroupSectorComercialViewDTOFields.PerteneceASector]: boolean
}

export enum GroupCoordinadorViewDTOFields {
    IdPerfil = 'idPerfil',
    IdGrupoPadre = 'idGrupoPadre'
}

export type GroupCoordinadorViewDTO = EntityWithIdAndDescription & {
    [GroupCoordinadorViewDTOFields.IdPerfil]: number
    [GroupCoordinadorViewDTOFields.IdGrupoPadre]: number
}

export enum GroupUserFields {
    UserId = 'idUsuario',
    Position = 'cargo',
    Mail = 'mail',
    FullName = 'nombreCompleto',
    LastLoginDate = 'fechaUltAcceso',
    GroupAssigned = 'perteneceAGrupo',
}

export interface GroupUserViewDTO {
    [GroupUserFields.UserId]: number
    [GroupUserFields.Position]: string
    [GroupUserFields.Mail]: string
    [GroupUserFields.FullName]: string
    [GroupUserFields.GroupAssigned]: boolean
    [GroupUserFields.LastLoginDate]: Date
}

export type GroupUserListResponseDTO = {
    disponibles: GroupUserViewDTO[]
    asignados: GroupUserViewDTO[]
}